import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import LazyLoad from 'react-lazy-load';
import * as styles from './Image.style';
export const Image = _ref => {
  let {
    dataRef = 'image',
    lazyLoad = true,
    src,
    srcSetData,
    alt,
    responsive,
    width,
    height,
    fit,
    loading,
    offset,
    ...rest
  } = _ref;
  const image = /*#__PURE__*/React.createElement(_StyledFigure, {
    $heightSize: height,
    $responsive: responsive,
    $fit: fit,
    $_css: styles.figure
  }, /*#__PURE__*/React.createElement("img", _extends({
    "data-ref": `${dataRef}-img`,
    src: src,
    alt: alt,
    loading: loading
  }, srcSetData || {}, rest)));
  if (!lazyLoad) {
    return image;
  }
  return /*#__PURE__*/React.createElement(_StyledLazyLoad, {
    width: width,
    height: height,
    offset: offset,
    $_css2: styles.frame
  }, image);
};
export default Image;
var _StyledFigure = _styled("figure").withConfig({
  displayName: "Image___StyledFigure",
  componentId: "sc-pt8k45-0"
})(["", ""], p => p.$_css);
var _StyledLazyLoad = _styled(LazyLoad).withConfig({
  displayName: "Image___StyledLazyLoad",
  componentId: "sc-pt8k45-1"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=Image.js.map